<style scoped>
 .v-text-field >>> .v-select__selection {
   font-size: 0.8em;
 }
 .v-text-field >>> label {
   font-size: 0.8em;
 }
 .v-text-field >>> button {
   font-size: 0.2em;
 }
</style>
<template>
    <div class="container-00">
      <div class="osc-block-00 osc-border-00 card-00">
        <div class="card-title-00">
          {{ parameter_group_title }} &nbsp;
          <v-btn x-small icon v-on:click="dump_effects_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
        </div>

        <!-- --------------------- -->
        <div class="knob-block-00">
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00">CHORUS</div><div>WET 1</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusWetLev1" v-on:change="onUpdateParam('chorusWetLev1', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Wet Level 1<br/>%s %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">FDBK</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusFeedback" v-on:change="onUpdateParam('chorusFeedback', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Feedback<br/>%s %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="justify-align--start">DRY</div><div>LEVEL</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusDryLevel" v-on:change="onUpdateParam('chorusDryLevel', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="DRY LEVEL<br/>%d %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="justify-align--start">LFO</div><div>FREQ</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusLFOfreq" v-on:change="onUpdateParam('chorusLFOfreq', $event.target.value)" conv="(x/10).toFixed(1)"  tooltip="LFO FREQ<br/>%s Hz"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">WET 2</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusWetLev2" v-on:change="onUpdateParam('chorusWetLev2', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Wet Level 2<br/>%s %"></webaudio-knob></div>
            </div>
          </div>
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DELAY1</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusDelay1" v-on:change="onUpdateParam('chorusDelay1', $event.target.value)" conv="x" tooltip="Delay 1<br/>%s msec"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">MOD 1</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusModLev1" v-on:change="onUpdateParam('chorusModLev1', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Mod Level 1<br/>%s %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">ON/OFF</div>
              <div class="knob-ctrl-00 justify-align-center"><webaudio-switch id="sw1" colors="#0f0;#fff;#fff" :value="effect_param.chorusSwitch" v-on:change="onUpdateParam('chorusSwitch', $event.target.value)"></webaudio-switch></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DELAY2</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusDelay2" v-on:change="onUpdateParam('chorusDelay2', $event.target.value)" conv="x" tooltip="Delay 2<br/>%s msec"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">MOD 2</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.chorusModLev2" v-on:change="onUpdateParam('chorusModLev2', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="MOD Level 2<br/>%s %"></webaudio-knob></div>
            </div>
          </div>
        </div>

        <!-- --------------------- -->
        <div class="knob-block-00 common-border-01">
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00">DELAY</div><div>TIME</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.delayTime" v-on:change="onUpdateParam('delayTime', $event.target.value)" conv="(x/100).toFixed(2)" tooltip="Delay Time<br/>%s sec"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">FDBK</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.delayFeedback" v-on:change="onUpdateParam('delayFeedback', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Feedback<br/>%d %"></webaudio-knob></div>
            </div>
          </div>
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DAMP</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.delayDamp" v-on:change="onUpdateParam('delayDamp', $event.target.value)"  conv="Math.round(100 * x / 127)" tooltip="Damping Frequency<br/>%d %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">LEVEL</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.delayLevel" v-on:change="onUpdateParam('delayLevel', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Delay Level<br/>%d %"></webaudio-knob></div>
            </div>
          </div>
        </div>

        <!-- --------------------- -->
        <div class="knob-block-00 common-border-01">
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00">REVERB</div><div>TIME</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="10" max="50" :value="effect_param.reverbTime" v-on:change="onUpdateParam('reverbTime', $event.target.value)"  conv="((x-10)/10).toFixed(1)" tooltip="Reverb Time<br/>%s msec"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="justify-align--start">DNS</div><!--div>:EARLY</div--></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.reverbDensity" v-on:change="onUpdateParam('reverbDensity', $event.target.value)"  conv="Math.round(100 * x / 127)" tooltip="Density<br/>%d %"></webaudio-knob></div>
            </div>
          </div>
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DAMP</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="54" max="74" :value="effect_param.reverbDamp" v-on:change="onUpdateParam('reverbDamp', $event.target.value)"  conv="const val=x-64; (val>0) ? '+' + val : val" tooltip="Damping Frequency<br/>%d"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">LEVEL</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="effect_param.reverbLevel" v-on:change="onUpdateParam('reverbLevel', $event.target.value)"  conv="Math.round(100 * x / 127)" tooltip="Level<br/>%d %"></webaudio-knob></div>
            </div>
          </div>
        </div>

      </div>
    </div>
</template>

<script>
 export default {
   name: 'Effects',
   props: ['parameter_group_title', 'label', 'effectsparam', 'select_items'],
   methods: {
     dump_effects_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[store:${this.label}]`, workingPatch.decoded)
       console.log(`[local:${this.label}]`, this.$data.effect_param)
       //console.log(`[${this.label}]`, this.$data.effect_param)
     },
     onUpdateParam: function(key, val) {
       //console.log(this.formant_param, key, val, this.$data)
       //const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       //const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       //console.log(this.label, workingPatch)
       this.$set(this.$data.effect_param, key, val)
       this.$store.commit('onEditOneEditPatch', {arr_idx: [key], value: Uint8Array.from([val])})

       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }

   },
   created: function() {
     //this.$data.label = this.in_label
     console.log(`<CREATED> label=[${this.label}]`)
     Object.keys(this.effectsparam).forEach( key => {
       this.$data.effect_param[key] = this.effectsparam[key]
     })
   },
   computed: {
     testCount: {
       get () {
         return this.$store.getters.getTestCount()
       },
       //set (value) {
       //this.$store.commit('onTestChange', value)
       //}
     }
   },
   data: () => ({
     v_select_background_color: '#fffef2',
     effect_param: {
       chorusSwitch: false,
       chorus_nrpn: 1,
       chorusFeedback: 20,
       chorusDelay1: 25,
       chorusLFOfreq: 30,
       chorusModLev1: 35,
       chorusDryLevel: 40,
       chorusWetLev1: 45,
       chorusDelay2: 25,
       chorusModLev2: 35,
       chorusWetLev2: 45,
       delayTime: 50,
       delayDamp: 55,
       delayFeedback: 60,
       delayLevel: 65,
       reverbTime: 70,
       reverbDamp: 75,
       reverbDensity: 80,
       reverbLevel: 85,
     }
   })
 }
</script>
